import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './theme/theme.css';
import App from './App';
import { getInitialTheme } from './theme/ThemeContext';
import reportWebVitals from './reportWebVitals';

document.documentElement.setAttribute('data-theme', getInitialTheme());

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
